import styled from 'styled-components';

export const ExplorerSurface = styled.div`
  color: #dce6f2; font-size: 14px; line-height: 1.5;
  min-width: 0;
  button, input, select, textarea { font-family: inherit; }
  button { transition: border-color .15s ease, background-color .15s ease; }
  button:disabled { cursor: not-allowed; opacity: .55; }
  button:focus-visible, input:focus-visible, select:focus-visible, summary:focus-visible {
    outline: 2px solid #7dd3fc; outline-offset: 3px;
  }
  .workspace-heading { display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 16px; margin-bottom: 24px; }
  .workspace-heading h2 { margin: 0; font-size: 24px; font-weight: 650; letter-spacing: -.025em; color: #f1f5f9; }
  .workspace-heading p { margin: 6px 0 0; color: #a2b3c9; max-width: 65ch; font-size: 14px; }
  .eyebrow { display: flex; align-items: center; gap: 7px; color: #8fcaba; font-size: 12px; margin-bottom: 8px; }
  .summary-grid { display: grid; grid-template-columns: repeat(5,minmax(0,1fr)); gap: 12px; }
  .summary-grid button:hover { box-shadow: inset 0 0 0 1px #64748b; }
  .section-heading { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; margin: 24px 0 12px; }
  .section-heading h3 { margin: 0; font-size: 17px; color: #f1f5f9; }
  .section-heading p { margin: 3px 0 0; color: #9aaec6; font-size: 13px; }
  .filter-bar { display: grid; grid-template-columns: minmax(180px,1.4fr) minmax(160px,1fr) minmax(170px,1fr) minmax(130px,.7fr) auto; gap: 10px; align-items: end; }
  .filter-bar input, .filter-bar select { width: 100%; box-sizing: border-box; min-width: 0; }
  .filter-bar label > span { display: block; color: #a2b3c9; font-size: 12px; margin-bottom: 6px; }
  .comparison-controls { display: flex; align-items: end; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
  .loan-table { overflow: auto; max-height: 640px; margin-top: 18px; border: 1px solid #29384d; border-radius: 12px; }
  .loan-table-header, .loan-row { min-width: 950px; }
  .loan-table-header { position: sticky; top: 0; z-index: 1; }
  .loan-row:hover { background: #152840 !important; }
  .loan-row:focus-visible { outline-offset: -3px; }
  .loan-table-header > div:nth-child(2), .loan-row > div:nth-child(2) { text-align: right; font-variant-numeric: tabular-nums; }
  .loan-table-header > div:nth-child(5), .loan-row > div:nth-child(5) { text-align: right; font-variant-numeric: tabular-nums; }
  .evidence-scroll { overflow-x: auto; }
  .evidence-scroll > div { min-width: 650px; }
  .pagination { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; margin-top: 16px; }
  .empty-state { padding: 64px 24px; text-align: center; border: 1px solid #29384d; border-radius: 16px; background: #0d1829; }
  .empty-state h2 { font-size: 22px; color: #e2e8f0; }
  .empty-state p { max-width: 55ch; margin: 12px auto 24px; color: #a2b3c9; }
  .detail-grid { display: grid; grid-template-columns: minmax(0,1.6fr) minmax(0,1fr); gap: 16px; }
  .detail-facts { display: grid; grid-template-columns: repeat(auto-fit,minmax(160px,1fr)); gap: 12px; }
  @media(max-width:1200px) {
    .summary-grid { grid-template-columns: repeat(3,minmax(0,1fr)); }
    .filter-bar { grid-template-columns: repeat(2,minmax(0,1fr)); }
  }
  @media(max-width:700px) {
    .summary-grid { grid-template-columns: repeat(2,minmax(0,1fr)); }
    .detail-grid { grid-template-columns: minmax(0,1fr); }
  }
  @media(max-width:440px) { .filter-bar { grid-template-columns: minmax(0,1fr); } }
  @media(prefers-reduced-motion:reduce) { button { transition: none; } }
`;

export const LoanDialog = styled.dialog`
  /* Centre the modal ourselves: the CSS reset zeroes every margin, including the auto margin a
     browser uses to centre a modal dialog, which left it in the top-left corner. */
  margin: auto;
  width: min(1152px,calc(100vw - 32px)); max-width: none; max-height: calc(100dvh - 48px);
  padding: 0; border: 1px solid #465870; border-radius: 18px; color: #dce6f2;
  background: #0c1626; box-shadow: 0 30px 100px #0008;
  &::backdrop { background: rgba(2,6,23,.78); backdrop-filter: blur(4px); }
`;
